export default [
    "Industrial", 
    "MT Retail", 
    "Multi-Family", 
    "Office",
    "STNL Retail"
];
// They should be in alphabetical order